<template>
  <div>
    <div class="content" style="width:auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ typeName }}</span>
      </div>
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width:88%;display: flex">
            <div class="start-label" />
            <span class="text">转库基础信息</span>
          </div>

          <el-row>
            <el-col :span="6">
              <el-form-item label="转库单号" prop="no">
                <el-input disabled v-model="form.no" placeholder="系统自动生成报修单号" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建人" prop="createdUserName">
                <el-input v-model="form.createdUserName" disabled style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建日期" prop="createdTime">
                <el-date-picker disabled v-model="form.createdTime" style="width: 90%" type="date" value-format="yyyy-MM-dd" placeholder="系统默认为当前日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="原使用库房" prop="oldWarehouseName">
                <el-select :disabled="!editMode" v-model="form.oldWarehouseName" style="width: 90%" filterable placeholder="请选择原使用库房" :filter-method="getWarehouses" @change="oldWarehouseChange">
                  <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="原库房管理员" prop="oldWarehouseManagerName">
                <el-input disabled v-model="form.oldWarehouseManagerName" placeholder="系统自动带出原库房管理员" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="新使用库房" prop="newWarehouseName">
                <el-select :disabled="!editMode" v-model="form.newWarehouseName" style="width: 90%" filterable placeholder="请选择新使用库房" :filter-method="getWarehouses" @change="newWarehouseChange">
                  <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="新库房管理员" prop="newWarehouseManagerName">
                <el-input disabled v-model="form.newWarehouseManagerName" placeholder="系统自动带出新库房管理员" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="库房地点" prop="address">
                <el-input v-model="form.address" :disabled="!editMode" style="width:90%" placeholder="请填写库房地点"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="转库日期" prop="date">
                <el-date-picker :disabled="!editMode" v-model="form.date" style="width: 90%" type="date" value-format="yyyy-MM-dd" placeholder="请选择转库日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="总数量" prop="toTalNumber">
                <el-input disabled v-model="form.toTalNumber" placeholder="根据详细信息数量求和汇总" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="总金额" prop="totalAmount">
                <el-input-number disabled v-model="form.totalAmount" :min="0" :precision="4" :controls="false" placeholder="根据详细信息金额求和汇总" style="width:90%"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="转库原因" prop="reason">
                <el-input :disabled="!editMode" v-model="form.reason" placeholder="请填写转库原因" resize="none" type="textarea" :rows="5" style="width:95%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!editMode" v-model="form.remark" placeholder="请填写备注" resize="none" type="textarea" :rows="5" style="width:95%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <AssetInfoEdit ref="AssetInfoEditRef" :data="form.details" :canEdit="true" :typeName="typeName" :ParentForm="form" :FixedAssetParam="{ warehouseId: form.oldWarehouseId ,StocktakingCategory: 1}" @autoTotalAmount="autoTotalAmount" :isRepeatMethod="isRepeatMethod" isRepeatMsg="当前转库信息已存在，请去子表编辑！" :mustCard="true" />
        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="$router.go(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import GetDataMixin from "@/mixin/getData-mixin.js";
import {
  GetWarehouseAssetTransferById,
  SaveWarehouseAssetTransfer,
  RejectWarehouseAssetTransfer,
} from "@/api";
import { WarehouseOutStockOptions } from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";
import AssetInfoEdit from "@/components/asset-into-edit";
export default {
  mixins: [GetDataMixin],
  components: {
    SelectTable,
    ApproveInfo,
    AssetInfoEdit,
  },
  /** 定义属性 */
  data () {
    return {
      typeName: "转库",
      form: {},
      WarehouseOutStockOptions: WarehouseOutStockOptions,
      rules: {
        oldWarehouseName: [
          { required: true, message: "原库房不能为空", trigger: "blur" },
        ],
        newWarehouseName: [
          { required: true, message: "新库房不能为空", trigger: "blur" },
        ],
        date: [
          { required: true, message: "转库日期不能为空", trigger: "blur" },
        ],
        reason: [
          { required: true, message: "转库原因不能为空", trigger: "blur" },
        ],
      },
      editMode: false,
      showWorkFlowInfo: false,
      assetList: [],
      reject: RejectWarehouseAssetTransfer,
    };
  },
  /** 计算属性，会监听依赖属性值随之变化 */
  computed: {},
  /** 监控data中的数据变化 */
  watch: {},
  /** 方法集合 */
  methods: {
    InitData () {
      var query = this.$route.query;
      if (query.id) {
        this.handleUpdate(query.id);
      } else {
        this.handleAdd();
      }
    },
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      GetWarehouseAssetTransferById({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        if (!this.form.details) {
          this.form.details = [];
        }
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.$refs.AssetInfoEditRef.setDetalis(this.form.details);
        this.initWorkFlowProperty(this.form);
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });
      });
    },
    /**
     * 初始化表单
     */
    resetForm () {
      this.form = {
        createdUserName: this.userInfo.name,
        createdTime: this.parseTime(new Date(), "{y}-{m}-{d}"),
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        warehouseId: null,
        warehouseName: null,
        warehouseManagerId: null,
        warehouseManagerName: null,
        backWarehouseId: null,
        backWarehouseName: null,
        backWarehouseManagerId: null,
        backWarehouseManagerName: null,
        userName: null,
        phone: null,
        toTalNumber: null,
        totalAmount: null,
        details: [],
        orgCode :sessionStorage.getItem('orgId')
      };
    },
    // 保存
    submit () {
      this.form.details = this.$refs.AssetInfoEditRef.getDetails();
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SaveWarehouseAssetTransfer(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          this.$router.push({ path: this.getMainPath(this.$route.path) });
        });
      });
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      this.$router.push({ path: this.getMainPath(this.$route.path) });
    },
    /**
     * 原库房选择
     */
    oldWarehouseChange (val) {
      let item = this.STATIC_Warehouses.find((e) => e.id == val);
      if (item) {
        this.form.oldWarehouseId = item.id;
        this.form.oldWarehouseManagerId = item.managerId;
        this.form.oldWarehouseManagerName = item.managerName;
      }
      window.setTimeout(() => {
        this.$refs.AssetInfoEditRef.getFixedAssetList("");
      }, 200);
    },
    /**
     * 新库房选择
     */
    newWarehouseChange (val) {
      let item = this.STATIC_Warehouses.find((e) => e.id == val);
      if (item) {
        this.form.newWarehouseId = item.id;
        this.form.newWarehouseManagerId = item.managerId;
        this.form.newWarehouseManagerName = item.managerName;
      }
    },
    autoTotalAmount (e) {
      let toTalNumber = 0;
      let totalAmount = 0;
      this.form.details = e;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        toTalNumber = toTalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.toTalNumber = toTalNumber;
      this.form.totalAmount = totalAmount;
    },
    isRepeatMethod (arr, row) {
      let item = arr.find(
        (e) =>
          e.$index != row.$index &&
          e.assetId == row.assetId &&
          e.price == row.price &&
          e.locationName == row.locationName &&
          e.assetSource == row.assetSource &&
          e.packDesc == row.packDesc &&
          e.manufacturerId == row.manufacturerId &&
          e.certId == row.certId &&
          e.brandId == row.brandId
      );
      if (item) {
        return true;
      } else {
        return false;
      }
    },
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    this.InitData();
  },
  /** 生命周期 - 挂载完成（可以访问DOM元素） */
  mounted () {
    this.$refs.AssetInfoEditRef.getFixedAssetList();
    this.getWarehouses();
  },
  /** 生命周期 - 创建之前 */
  beforeCreate () { },
  /** 生命周期 - 挂载之前 */
  beforeMount () { },
  /** 生命周期 - 更新之前 */
  beforeUpdate () { },
  /** 生命周期 - 更新之后 */
  updated () { },
  /** 生命周期 - 销毁之前 */
  beforeDestroy () { },
  /** 生命周期 - 销毁完成 */
  destroyed () { },
  /** 如果页面有keep-alive缓存功能，这个函数会触发 */
  activated () { },
};
</script>

<style lang="scss" scoped></style>
